import React, { useState, useMemo, useEffect } from "react";
import "./index.scss";
import Header from "../../../components/Header";
import Menu from "../../../components/Menu";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InitialState from "./initialState";
import ReactQuill, { Quill } from "react-quill";
import ApiContent from "../../../api/ApiContent";
import { WEB_IMAGE } from "../../../env";
import Swal from "sweetalert2";
import { ConvertDateShort } from "../../../utils/date";
import CSwal from "../../../utils/alert";
import Select from "react-select";
import ApiCategory from "../../../api/ApiCategory";
import { TagsInput as ReactTags } from "react-tag-input-component";
import { useHistory } from "react-router-dom";
import { arrayRemoveByIndex, CheckFile, destroyPage, useWindowUnloadEffect } from "../../../utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PostV2Preview from "../../../components/PostV2Preview";
import PostDetailPreview from "../../../components/PostBackendPreview";
import Drawer from 'rc-drawer';
import "rc-drawer/assets/index.css";
import MenuDrawer from "../../../components/MenuDrawer";
import Autosuggest from 'react-autosuggest';
import ApiTranProfile from "../../../api/ApiTranProfile";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ApiOrg from "../../../api/ApiOrg";
import ApiConfig from "../../../api/ApiConfig";
import _ from 'lodash';
import IconComponent from "../../../components/Icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tab } from '@headlessui/react'
import { ArrowDownCircleIcon, ArrowUpCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import MainPost from "../../../components/PostV2";
import PostContentGroup from "../../../components/PostContentGroup";
window.Quill = Quill;

const ImageResize = require("quill-image-resize-module").default;
Quill.register("modules/imageResize", ImageResize);

const CreateContent = () => {
  const [firstTime, setFirstTime] = useState(new Date());
  useWindowUnloadEffect(() => destroyPage({ page: "Create Content", firstTime: firstTime }), true);
  const userState = useSelector((state) => state.user);
  const [searchCapacity, setsearchCapacity] = useState('');
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [state, setState] = useState(InitialState);
  const [catagory, setcatagory] = useState([]);
  const [tags, setTags] = React.useState([]);
  const [fileDocState, setfileDocState] = useState([]);
  const [fileVideoState, setVideoState] = useState("");
  const [isCalendar, setisCalendar] = useState(false);
  const [postDate, setpostDate] = useState(new Date());
  const [isModal, setisModal] = useState(false);
  const [isModalContentGroup, setisModalContentGroup] = useState(false);
  //const [dataPreview, setdataPreview] = useState({ "isLike": false, "usernameProfile": null, "imageProfile": "Profile/3_2021_09_24_10_56_26_Paris_RER_A_icon.svg.png", "employee": { "employeeFileId": 2, "peoplesoftId": "00000028", "employmentStatusCode": "3", "employmentStatusText": "Active", "mainPosition": "Y", "scGEmployeeId": "0250-000483", "alterEmpid": "3360400729182", "nameTitleThai": "นาย", "firstNameThai": "สมชาย", "lastNameThai": "ราชโนนเขวา", "nameTitleEnglish": "Mr.", "firstNameEnglish": "Somchai", "lastNameEnglish": "Rachnonkhwao", "userId": "somchrac", "company": "0250", "companyDescription": "Thai Containers Group Co., Ltd.", "companyThai": "บริษัทกลุ่มสยามบรรจุภัณฑ์ จำกัด", "positionNameEnglish": "Stacker Machine Operator", "positionNameThai": "พนักงานควบคุม Stacker", "positionNumber": "90000729", "positionDescription": "พนักงานควบคุม Stacker", "action": "Z7", "actionDate": "01.01.2021", "departmentId": "90004021", "departmentDescription": "Corrugating Section", "employeeDepartmentDescriptionThai": "", "sub1BusinessUnitEnglish": "", "sub1BusinessUnitThai": "", "sub11BusinessUnitEnglish": "Consumer & Industrial Packaging", "sub11BusinessUnitThai": "Consumer & Industrial Packaging", "sub1CompanyEnglish": "TCSP (Unofficial Org)", "sub1CompanyThai": "TCSP (Unofficial Org)", "divisionEnglish": "TCSP", "divisionThai": "TCSP", "sub1DivisionEnglish": "", "sub1DivisionThai": "", "departmentThai": "Production Department", "sub1DepartmentEnglish": "", "sub1DepartmentThai": "", "sectionEnglish": "Corrugating Section", "sectionThai": "Corrugating Section", "sub1SectionEnglish": "", "sub1SectionThai": "", "shiftEnglish": "", "shiftThai": "", "sub1ShiftEnglish": "", "sub1ShiftThai": "", "location": "025T0A", "locationDescription": "TCG - TCSP - Samut Prakan @13.543164,100.663218", "businessUnit": "PPB", "businessUnitDescriptionEnglish": "SCG Packaging", "businessUnitDescriptionThai": "เอสซีจี แพคเกจจิ้ง", "manager": "Mr. Piput Uhsuwan", "employeeClass": "B", "employeeClassDescription": "Permanent Employee", "plGroup": "O3", "plGroupDescription": "", "plEmployeeSubgroupObjects": "", "plDate": "", "birthday": "03.02.1977", "gender": "M", "nationality": "TH", "martialStatus": "", "address1": "", "address2": "", "address3": "", "address4": "", "city": "", "state1": "", "postal": "", "telephoneHome": "", "addressOffiice": "", "officeAddressFloor": "", "officeAddressRoom": "", "officeAddressProvince": "", "telephoneBusiness": "", "telephoneBeside": "", "spouseName": "", "spouseLastName": "", "highestEducationLevel": "", "education": "", "bloodType": "", "hireDate": "", "positionEntryDate": "", "employeeTypeId": "", "nationalId": "", "email": "SOMCHRAC@SCG.COM", "reportTo": "Mr. Piput Uhsuwan", "reportToPositionName": "หผ.ผลิตแผ่นลูกฟูก", "reportEmployeeId": "10001646", "reportName": "Mr. Piput Uhsuwan", "reportEmail": "PIPUTU@SCG.COM", "managerPosition": "90005758", "managerScgEmpId": "0250-001860", "managerSUserId": "PIPUTU", "nickName": "", "telephoneMobile": "", "emergencyContactNamePrimary": "", "emergencyContactTelephoneNumberPrimary": "", "emergencyContactMobileNumberPrimary": "", "emailHome": "", "emailOther": "", "costCenterDept": "0253-01009", "organizationUnitIdOfParentNode": "90001004", "costCenterOver": "", "terminationDate": "", "serviceYear": "", "serviceMonths": "", "terminateReason": "", "taxId": "", "accountLocked": "", "lastSignOnDateTime": "", "lastUpdateDateTime": "", "vendorCustomerId": "", "flagIinsertDdeleteUupdate": "", "systemDateTime": "", "bankIdPrimary": "", "branchIdPrimary": "", "bankNamePrimary": "", "banchNamePrimary": "", "accountId": "", "oldCompany": "", "oldScgEmpId": "", "middleName": "", "createdDate": "2021-08-13T04:34:00", "createdBy": 0, "isDeleted": false, "reportToName": "Mr. Piput Uhsuwan", "reportToEmail": "PIPUTU@SCG.COM", "reportToUserId": "PIPUTU", "state": 0 }, "comments": null, "related": null, "id": 11, "profileid": 3, "ctrefno": null, "cttrandate": "2021-10-14T14:55:17.157", "ctpostdate": "2021-10-14T07:54:26.937", "ctname": "Here’s a list of technologies I wasted time learning as a Web Developer", "ctdeschtml": "<p><img src=\"https://api-km.makersoft.co.th/HTML/recycle.png\"></p><p>When I started learning Web Development back in 2015, I wasted a lot of time learning whatever technologies I came across in articles and tutorials online.</p><p>In an industry with an ever growing number of technologies, libraries, and frameworks, being efficient with your learning is key. So whether you’re new to Web Development, or you already have some skin in the game, here’s a list of things that I either wasted my time learning and never actually used in my professional career, or are things that are no longer relevant in 2021 (ie, you can get away with not knowing).</p><h2>Ruby / Ruby-on-rails</h2><p><span style=\"color: rgb(41, 41, 41);\">Ruby-on-Rails was big in the late 2000s. I wasted several months trying to build applications with Ruby-on-Rails. While some big tech companies will still have some Rails code in their codebase, I’ve rarely come across any companies in recent years making use of it. In fact, six years into my professional career and I’ve not once had to use Rails. And even more so, I wouldn’t want to.</span></p>", "ctlikeAmt": 0, "ctcommentAmt": 0, "ctstatus": "A", "ctcatagoryid": null, "ctcatagoryJson": null, "cttagid": null, "cttagtJson": "[{\"Id\":0,\"Name\":\"React.js\"},{\"Id\":0,\"Name\":\"Web Developer\"}]", "ctfavProfileJson": null, "ctfiledoc": null, "ctfilevideo": null, "recordstatus": null, "createdate": "2021-10-14T14:55:17.157", "createby": null, "updatedate": "2021-10-14T14:55:17.157", "updateby": null, "approvedate": null, "remark": null, "smecase": null });
  const [dataPreview, setdataPreview] = useState({});
  const [isPreview, setisPreview] = useState(false);
  var quillObj = React.useRef(null);
  var form = React.useRef(null);
  const [suggestion, setsuggestion] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [suggestionSelect, setsuggestionsSelect] = useState([]);

  const [suggestionUser, setsuggestionUser] = useState('');
  const [suggestionsUser, setSuggestionsUser] = useState([]);
  const [suggestionSelectUser, setsuggestionsSelectUser] = useState([]);

  const [suggestionContentGroup, setSuggestionContentGroup] = useState('');
  const [suggestionContentGroups, setSuggestionContentGroups] = useState([]);
  const [suggestionContentGroupSelect, setSuggestionContentGroupSelect] = useState([]);

  const [contentGroupSelect, setContentGroupSelect] = useState([]);

  const [capabilitiesDefault, setCapabilitiesDefault] = useState([])
  const [capabilities, setCapabilities] = useState([])

  const [contentType, setcontentType] = useState('CONTENT');

  const [stateOrg, setstateOrg] = useState({
    orgData: [],
    bu: [],
    subbu: [],
    company: [],
    division: [],
    sub_division: [],
    department: [],
    sub_department: [],
    section: []
  });

  const filterOption = ({ label, value }, string) => {
    // default search
    if (label.includes(string) || value.includes(string)) return true;

    // check if a group as the filter string as label
    const groupOptions = capabilities.filter(group => {
      return group.label.toLocaleLowerCase().includes(string.toLocaleLowerCase())
    }
    );

    if (groupOptions) {
      for (const groupOption of groupOptions) {
        // Check if current option is in group
        const option = groupOption.options.find(opt => opt.value === value);
        if (option) {
          return true;
        }
      }
    }
    return false;
  };

  const imageHandler = (image, callback) => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      var file = input.files[0];
      var formData = new FormData();

      formData.append("image", file);

      var fileName = file.name;

      uploadFiles(file, fileName, quillObj.current);
    };
  };

  const modules = useMemo(
    () => ({
      imageResize: {
        // See optional "config" below
      },
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"], // toggled buttons
          ["blockquote", "code-block"],
          [{ header: 1 }, { header: 2 }], // custom button values
          [{ list: "ordered" }, { list: "bullet" }],
          [{ script: "sub" }, { script: "super" }], // superscript/subscript
          [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
          [{ direction: "rtl" }], // text direction
          [{ size: ["small", false, "large", "huge"] }], // custom dropdown
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ color: [] }, { background: [] }], // dropdown with defaults from theme
          [{ font: [] }],
          [{ align: [] }],
          ["link", "image"],
          ["clean"], // remove formatting button
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  const getCompetency = async () => {
    const result = await ApiConfig.getCompetency();
    if (result.status == 200) {
      if (result.data.data.length > 0) {
        //setTrend(result.data.data);
        var groupBySizeBox = _(result.data.data)
          .groupBy('ocap')
          .map((value, key) => {
            return {
              label: key, options: value.map(x => {
                return { label: `(${x.fcno}) ${x.competencyNameTh}`, value: x.fcno };
              })
            }
          })
          .value();
        setCapabilities(groupBySizeBox);
        setCapabilitiesDefault(result.data.data.map(x => {
          return { label: `(${x.fcno}) ${x.competencyNameTh}`, value: x.fcno, description: x.competencyDifination };
        }));
        return result.data.data.map(x => {
          return { label: `(${x.fcno}) ${x.competencyNameTh}`, value: x.fcno };
        });
      }
    }
  };

  const uploadFiles = async (uploadFileObj, filename, quillObj) => {
    Swal.showLoading();
    const range = quillObj.getEditorSelection();
    console.log(range);
    console.log(uploadFileObj);
    console.log(filename);
    const formData = new FormData();
    formData.append("file", uploadFileObj);
    const result = await ApiContent.uploadHtmlFile(formData);
    const { data } = result.data;
    quillObj
      .getEditor()
      .insertEmbed(range.index, "image", process.env.REACT_APP_IMAGE + data.path);
    Swal.close();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if(contentType == "CONTENT"){
      state.ctstatus = "W";
      CSwal.SwalLoad();
      const regex = /(<([^>]+)>)/gi;
      const content_html = state.ctdeschtml.replace(regex, "");
      let jsonCatagoryId = {};
      let jsonCatagoryJson = {};
      let jsonRef = "";
      let jsonRefUser = "";
      if (content_html == "") {
        CSwal.SwalErr("กรุณากรอกรายละเอียดองค์ความรู้");
        return false;
      }
  
      if (state.ctcatagoryJson.length > 0) {
        jsonCatagoryId = state.ctcatagoryJson
          .map((x) => {
            return x.value;
          })
          .join(",");
        jsonCatagoryJson = state.ctcatagoryJson.map((x) => {
          return { Id: x.value, Name: x.label };
        });
      } else {
        CSwal.SwalErr("กรุณากรอกหมวดหมู่ขององค์ความรู้");
        return false;
      }
  
      if (tags.length > 0) {
        state.cttagtJson = tags.map(x => { return { Id: 0, Name: x } });
      }
  
      if (suggestionSelect.length > 0) {
        jsonRef = suggestionSelect.map((x) => {
          return { id: x.id, ctname: x.ctname, ctrefno: x.ctrefno };
        });
      }
  
      if (suggestionSelectUser.length > 0) {
        jsonRefUser = suggestionSelectUser.map((x) => {
          return {
            id: x.id,
            firstNameEnglish: x.firstNameEnglish,
            lastNameEnglish: x.lastNameEnglish,
          };
        });
      }
  
      try {
        const created = await ApiContent.create(
          {
            ...state,
            bu: state.bu.join(','),
            subbu: state.subbu.join(','),
            company: state.company.join(','),
            division: state.division.join(','),
            sub_division: state.sub_division.join(','),
            department: state.department.join(','),
            sub_department: state.sub_department.join(','),
            section: state.section.join(','),
            ctcatagoryid: jsonCatagoryId,
            ctcatagoryJson: jsonCatagoryJson,
            contentRefJson: jsonRef ? JSON.stringify(jsonRef) : "",
            contentUserRefJson: jsonRefUser ? JSON.stringify(jsonRefUser) : "",
            competency: state.competency.length > 0 ? state.competency.map(x => x.value).join(',') : "",
          });
        const formData = new FormData();
        if (fileDocState) {
          fileDocState.map((item) => {
            formData.append("file", item);
          })
        }
        if (fileVideoState) {
          formData.append("video", fileVideoState);
        }
        const refno = created.data.data.ctrefno;
        formData.append("refno", refno);
        if (fileDocState || fileVideoState) {
          const uploadedFile = await ApiContent.upload(formData);
        }
        Swal.fire("สำเร็จ", "", "success").then(async (result) => {
          history.push("/contentwaiting");
        });
      } catch (error) {
        try {
          const { data } = error.response;
          CSwal.SwalErr(data.message);
        } catch (ex) {
          CSwal.SwalErr("ไม่สามารถสร้างบทความได้");
        }
      }
    }
    else{
      onSubmitContentGroup();
    }
  };

  const onSubmitContentGroup = async () => {
    state.ctstatus = "W";
    CSwal.SwalLoad();
    const regex = /(<([^>]+)>)/gi;
    const content_html = state.ctdeschtml.replace(regex, "");
    let jsonCatagoryId = {};
    let jsonCatagoryJson = {};
    let jsonRef = "";
    let jsonRefUser = "";
    let contentGroupJson = "";
    if (content_html == "") {
      CSwal.SwalErr("กรุณากรอกรายละเอียดองค์ความรู้");
      return false;
    }

    if (state.ctcatagoryJson.length > 0) {
      jsonCatagoryId = state.ctcatagoryJson
        .map((x) => {
          return x.value;
        })
        .join(",");
      jsonCatagoryJson = state.ctcatagoryJson.map((x) => {
        return { Id: x.value, Name: x.label };
      });
    } else {
      CSwal.SwalErr("กรุณากรอกหมวดหมู่ขององค์ความรู้");
      return false;
    }

    if (tags.length > 0) {
      state.cttagtJson = tags.map(x => { return { Id: 0, Name: x } });
    }

    if (suggestionSelect.length > 0) {
      jsonRef = suggestionSelect.map((x) => {
        return { id: x.id, ctname: x.ctname, ctrefno: x.ctrefno };
      });
    }

    if (suggestionSelectUser.length > 0) {
      jsonRefUser = suggestionSelectUser.map((x) => {
        return {
          id: x.id,
          firstNameEnglish: x.firstNameEnglish,
          lastNameEnglish: x.lastNameEnglish,
        };
      });
    }

    if (contentGroupSelect.length > 0) {
      contentGroupJson = contentGroupSelect.map((x) => {
        return { id: x.id, ctname: x.ctname, ctrefno: x.ctrefno };
      });
    }

    try {
      const created = await ApiContent.createLearningPath(
        {
          ...state,
          bu: state.bu.join(','),
          subbu: state.subbu.join(','),
          company: state.company.join(','),
          division: state.division.join(','),
          sub_division: state.sub_division.join(','),
          department: state.department.join(','),
          sub_department: state.sub_department.join(','),
          section: state.section.join(','),
          ctcatagoryid: jsonCatagoryId,
          ctcatagoryJson: jsonCatagoryJson,
          contentRefJson: jsonRef ? JSON.stringify(jsonRef) : "",
          contentUserRefJson: jsonRefUser ? JSON.stringify(jsonRefUser) : "",
          competency: state.competency.length > 0 ? state.competency.map(x => x.value).join(',') : "",
          contentGroups: contentGroupJson ? JSON.stringify(contentGroupJson) : "",
        });
      const formData = new FormData();
      if (fileDocState) {
        fileDocState.map((item) => {
          formData.append("file", item);
        })
      }
      if (fileVideoState) {
        formData.append("video", fileVideoState);
      }
      const refno = created.data.data.ctrefno;
      formData.append("refno", refno);
      if (fileDocState || fileVideoState) {
        const uploadedFile = await ApiContent.upload(formData);
      }
      Swal.fire("สำเร็จ", "", "success").then(async (result) => {
        history.push("/contentwaiting");
      });
    } catch (error) {
      try {
        const { data } = error.response;
        CSwal.SwalErr(data.message);
      } catch (ex) {
        CSwal.SwalErr("ไม่สามารถสร้างบทความได้");
      }
    }
  };

  const getCatagory = async () => {
    const result = await ApiCategory.get();
    const { data } = result.data;
    setcatagory(data);
  };

  useEffect(() => {
    const promise1 = getCatagory();
    const promise2 = getCompetency();
    Promise.all([promise1, promise2]).then(result => {

    })

    return () => { };
  }, []);

  useEffect(() => {
    if (state.isSpecific == 1) {
      func_loadOrg();
    }
    return () => { };
  }, [state.isSpecific]);

  const func_loadOrg = async () => {
    try {
      CSwal.SwalLoad();
      var res = await ApiOrg.getOrg();
      CSwal.SwalClose();
      const { result, status } = res.data;
      if (res.status === 200) {
        setstateOrg({
          ...stateOrg, orgData: result
        })
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          const { message } = err.response;
          console.log(message);
        }
      }
    }
  };

  const handleTagAddition = async (tag) => {
    setTags(tag);

    var tagModel = [];
    for (var i = 0; i < tag.length; i++) {
      var tagsub = {
        name: tag[i],
      };
      tagModel.push(tagsub);
    }
    setState({ ...state, cttagtJson: tagModel });
  };


  const draft = async () => {
    state.ctstatus = "D";
    CSwal.SwalLoad();
    const regex = /(<([^>]+)>)/gi;
    const content_html = state.ctdeschtml.replace(regex, "");
    let jsonCatagoryId = {};
    let jsonCatagoryJson = {};
    let jsonRef = "";
    let jsonRefUser = "";
    if (content_html == "") {
      CSwal.SwalErr("กรุณากรอกรายละเอียดองค์ความรู้");
      return false;
    }


    if (state.ctcatagoryJson.length > 0) {
      jsonCatagoryId = state.ctcatagoryJson
        .map((x) => {
          return x.value;
        })
        .join(",");
      jsonCatagoryJson = state.ctcatagoryJson.map((x) => {
        return { Id: x.value, Name: x.label };
      });
    } else {
      CSwal.SwalErr("กรุณากรอกหมวดหมู่ขององค์ความรู้");
      return false;
    }

    if (tags.length > 0) {
      state.cttagtJson = tags.map(x => { return { Id: 0, Name: x } });
    }
    if (suggestionSelect.length > 0) {
      jsonRef = suggestionSelect.map((x) => {
        return { id: x.id, ctname: x.ctname, ctrefno: x.ctrefno };
      });
    }
    if (suggestionSelectUser.length > 0) {
      jsonRefUser = suggestionSelectUser.map((x) => {
        return {
          id: x.id,
          firstNameEnglish: x.firstNameEnglish,
          lastNameEnglish: x.lastNameEnglish,
        };
      });
    }
    try {

      const created = await ApiContent.create(
        {
          ...state,
          bu: state.bu.join(','),
          subbu: state.subbu.join(','),
          company: state.company.join(','),
          division: state.division.join(','),
          sub_division: state.sub_division.join(','),
          department: state.department.join(','),
          sub_department: state.sub_department.join(','),
          section: state.section.join(','),
          ctcatagoryid: jsonCatagoryId,
          ctcatagoryJson: jsonCatagoryJson,
          contentRefJson: jsonRef ? JSON.stringify(jsonRef) : "",
          contentUserRefJson: jsonRefUser ? JSON.stringify(jsonRefUser) : "",
          competency: state.competency.length > 0 ? state.competency.map(x => x.value).join(',') : "",
        });

      const formData = new FormData();
      if (fileDocState) {
        formData.append("file", fileDocState);
      }
      if (fileVideoState) {
        formData.append("video", fileVideoState);
      }
      const refno = created.data.data.ctrefno;
      formData.append("refno", refno);
      if (fileDocState || fileVideoState) {
        const uploadedFile = await ApiContent.upload(formData);
      }
      Swal.fire("สำเร็จ", "", "success").then(async (result) => {
        history.push("/contentwaiting");
      });
    } catch (error) {
      try {
        const { data } = error.response;
        CSwal.SwalErr(data.message);
      } catch (ex) {
        CSwal.SwalErr("ไม่สามารถสร้างบทความได้");
      }
    }

  };

  const preview = async () => {
    state.ctstatus = "P";
    CSwal.SwalLoad();
    const regex = /(<([^>]+)>)/gi;
    const content_html = state.ctdeschtml.replace(regex, "");
    let jsonCatagoryId = {};
    let jsonCatagoryJson = {};
    if (content_html == "") {
      CSwal.SwalErr("กรุณากรอกรายละเอียดองค์ความรู้");
      return false;
    }

    if (state.ctcatagoryJson.length > 0) {
      jsonCatagoryId = state.ctcatagoryJson
        .map((x) => {
          return x.value;
        })
        .join(",");
      jsonCatagoryJson = state.ctcatagoryJson.map((x) => {
        return { Id: x.value, Name: x.label };
      });
    } else {
      CSwal.SwalErr("กรุณากรอกหมวดหมู่ขององค์ความรู้");
      return false;
    }


    if (tags.length > 0) {
      state.cttagtJson = tags.map(x => { return { Id: 0, Name: x } });
    }
    try {
      const created = await ApiContent.createPreview(
        {
          ...state,
          ctcatagoryid: jsonCatagoryId,
          ctcatagoryJson: jsonCatagoryJson
        });
      CSwal.SwalClose();
      if (created.status == 200) {
        const { data } = created.data;
        console.log(JSON.stringify(data));
        setdataPreview(data);
        setisPreview(true)
      }
    } catch (error) {
      const { data } = error.response;
      CSwal.SwalErr(data.message);
    }

  };

  const fileDoc = async (e) => {
    if (e.target.files.length == 0) return false;
    var file = e.target.files[0];
    if (CheckFile({
      file,
      size: 150,
      type: ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
      message: "รองรับเฉพาะไฟล์ .pdf,.docx,pptx เท่านั้น",
    })) {
      console.log([...fileDocState, file])
      setfileDocState([...fileDocState, file]);
    }
  };

  const fileVideo = async (e) => {
    if (e.target.files.length == 0) return false;
    var file = e.target.files[0];
    if (CheckFile({
      file,
      size: 150,
      type: ["video/mp4"],
      message: "รองรับเฉพาะไฟล์ .mp4 เท่านั้น",
    })) {
      setVideoState(file);
    };
  };

  const getSuggestions = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if (inputLength < 3) return [];
    else {
      try {
        const content = await ApiContent.GetAutocomplete(inputValue);
        if (content.status == 200) {
          const { data } = content;
          return data.data;
        }
      } catch (error) {
        return [];
      }
    }
  };

  const getSuggestionValue = (suggestion) => {
    const checked = suggestionSelect.find(x => x.ctrefno == suggestion.ctrefno);
    if (checked) {

    } else {
      setsuggestionsSelect([...suggestionSelect, suggestion])
    }

    return "";
  };

  const renderSuggestion = suggestion => (
    <div style={{ padding: 10, border: '1px solid #efefef' }}>
      {suggestion.ctname}
    </div>
  );

  const onSuggestionsFetchRequested = async ({ value }) => {
    setSuggestions(await getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onChangeSuggestion = (event, { newValue }) => {
    setsuggestion(newValue);
  };

  const getSuggestionsUser = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if (inputLength < 3) return [];
    else {
      try {
        const content = await ApiTranProfile.GetAutocomplete(inputValue);
        if (content.status == 200) {
          const { data } = content;
          return data.data;
        }
      } catch (error) {
        return [];
      }
    }
  };

  const getSuggestionValueUser = (suggestion) => {
    const checked = suggestionSelectUser.find(x => x.id == suggestion.id);
    if (checked) {
    } else {
      setsuggestionsSelectUser([...suggestionSelectUser, suggestion])
    }

    return "";
  };

  const renderSuggestionUser = suggestion => (
    <div style={{ padding: 10, border: '1px solid #efefef' }}>
      {suggestion.firstNameEnglish + " " + suggestion.lastNameEnglish}
    </div>
  );

  const onSuggestionsFetchRequestedUser = async ({ value }) => {

    setSuggestionsUser(await getSuggestionsUser(value));
  };

  const onSuggestionsClearRequestedUser = () => {
    setSuggestionsUser([]);
  };

  const onChangeSuggestionUser = (event, { newValue }) => {
    setsuggestionUser(newValue);
  };

  const getSuggestionContentGroups = async (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if (inputLength < 3) return [];
    else {
      try {
        const content = await ApiContent.GetAutocomplete(inputValue);
        if (content.status == 200) {
          const { data } = content;
          return data.data;
        }
      } catch (error) {
        return [];
      }
    }
  };

  const getSuggestionValueContentGroup = (suggestion) => {
    const checked = suggestionContentGroupSelect.find(x => x.ctrefno == suggestion.ctrefno);
    if (checked) {

    } else {
      setSuggestionContentGroupSelect([...suggestionContentGroupSelect, suggestion])
    }

    return "";
  };

  const renderSuggestionContentGroup = suggestion => (
    <div style={{ padding: 10, border: '1px solid #efefef' }}>
      {suggestion.ctname}
    </div>
  );

  const onSuggestionsContentGroupFetchRequested = async ({ value }) => {
    setSuggestionContentGroups(await getSuggestionContentGroups(value));
  };

  const onSuggestionsContentGroupClearRequested = () => {
    setSuggestionContentGroups([]);
  };

  const onChangeSuggestionContentGroup = (event, { newValue }) => {
    setSuggestionContentGroup(newValue);
  };

  // ฟังก์ชันเลื่อนตำแหน่งขึ้น
  const moveItemUp = (index) => {
    if (index > 0) {
      const newItems = [...contentGroupSelect];
      [newItems[index], newItems[index - 1]] = [newItems[index - 1], newItems[index]]; // สลับตำแหน่ง
      setContentGroupSelect(newItems);
    }
  };

  // ฟังก์ชันเลื่อนตำแหน่งลง
  const moveItemDown = (index) => {
    if (index < contentGroupSelect.length - 1) {
      const newItems = [...contentGroupSelect];
      [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]]; // สลับตำแหน่ง
      setContentGroupSelect(newItems);
    }
  };

  return (
    <div id="createContent-page">

      <Drawer className="is-hidden-desktop is-hidden-tablet">
        <MenuDrawer data={[]} page="rank" header={t('menu.createcontent')} />
      </Drawer>
      <Header />
      <div className="columns" style={{ height: "100%" }}>
        {/* section menu */}
        <div className="column is-hidden-mobile  is-2 layer">
          <Menu data={[]} page="rank" header={t('menu.createcontent')} />
        </div>
        <form ref={form} className="d-flex flex-1" onSubmit={onSubmit}>
          <div className="column is-8 border-div1">
            {isCalendar ? (
              <>
                <div className="is-flex is-justify-content-space-between m-4">
                  <div className="is-flex is-align-items-center">
                    <figure className="image mr-3">
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/content/IconTime.png"
                        }
                        alt="Icon"
                      />
                    </figure>
                    <p className="title-h1">กำหนดเวลาเผยแพร่</p>
                  </div>
                  <div className="is-flex">
                    <button
                      onClick={() => setisCalendar(false)}
                      type="button"
                      className="button is-outlined has-text-weight-bold has-background-light subtitle-p4 mx-2"
                    >
                      {t("menu.cancel")}
                    </button>
                  </div>
                </div>
                <div className="is-flex is-justify-content-space-between m-4">
                  <div className="is-flex is-align-items-center">
                    <p>เลือกวันและเวลาในการโพสต์</p>
                  </div>
                  <div className="is-flex">
                    <button
                      onClick={() => {
                        setState({ ...state, ctpostdate: postDate });
                        setisCalendar(false);
                      }}
                      type="button"
                      className="button is-outlined has-text-weight-bold has-text-white subtitle-p4 mx-2 size-button"
                      style={{ backgroundColor: "#F24C20" }}
                    >
                      {t('text.sche_content')}
                    </button>
                  </div>
                </div>
                <div className="is-flex is-justify-content-space-between m-4">
                  <DatePicker
                    className="input size-input"
                    selected={postDate}
                    onChange={(date) => setpostDate(date)}
                    showTimeSelect
                    dateFormat="dd/MM/yyyy hh:mm:aa"
                  />
                </div>
              </>
            ) : (
              <div className="is-flex is-justify-content-space-between is-flex-wrap-wrap size-wrap">
                <div className="is-flex is-align-items-center">
                  <figure className="image mr-3">
                    <img
                      src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                      alt="Icon"
                    />
                  </figure>
                  <p className="title-h1">{t('menu.createcontent')}</p>
                </div>
                <div className="is-flex">
                  <button
                    onClick={() => setisCalendar(true)}
                    type="button"
                    className="button is-outlined has-text-weight-bold has-background-light subtitle-p4 mx-2"
                  >
                    {t('text.sche_content')}
                  </button>
                  <button
                    type={"button"}
                    onClick={() => preview()}
                    className="button is-outlined has-text-weight-bold has-background-light subtitle-p4 mx-2"
                  >
                    {t('text.preview')}
                  </button>
                  <button
                    type={"submit"}
                    className="button is-outlined has-text-weight-bold has-text-white subtitle-p4 mx-2"
                    style={{ backgroundColor: "#F24C20" }}
                  >
                    {t('text.publish')}
                  </button>
                </div>
              </div>
            )}

            <hr className="hr-size1" />
            <div className="flex gap-2 mt-4 mb-4">
              <div onClick={() => {
                setcontentType("CONTENT")
              }} className={`cursor-pointer ${contentType == "CONTENT" && "text-[#f97316] font-bold underline orange-underline"}`}>
                {t('menu.createcontent')}
              </div>
              <div className={`cursor-pointer ${contentType == "LEARNING_PATH" && "text-[#f97316] font-bold underline orange-underline"}`}
                onClick={() => {
                  setcontentType("LEARNING_PATH")
                }}>
                {t('menu.createcontentGroup')}
              </div>
            </div>
            <hr className="hr-size1" />
            <div className="is-flex is-flex-direction-column size-col">
              <div className="is-flex is-justify-content-space-between is-align-items-center is-flex-wrap-wrap my-4 px-1">
                <p className="font">{t('text.content_name')}</p>
                <input
                  className="input size-input"
                  type="text"
                  placeholder="กรุณาระบุชื่อความรู้"
                  value={state.ctname}
                  required
                  onChange={(e) =>
                    setState({ ...state, ctname: e.target.value })
                  }
                />
              </div>

              <div className="is-flex is-flex-direction-column px-2">
                <p className="font">{t('text.content_desc')}</p>
                <ReactQuill
                  style={{ marginTop: 20, marginBottom: 20 }}
                  ref={quillObj}
                  value={state.ctdeschtml}
                  modules={modules}
                  onChange={(content, delta, source, editor) => {
                    setState({ ...state, ctdeschtml: content });
                  }}
                />
              </div>
              {/* inputFile */}
              <label classname="checkbox is-flex" style={{ marginBottom: 20 }}>
                <input
                  id={`checkgdc`}
                  type="checkbox"
                  onChange={(e) => {
                    setState({ ...state, isVerify: e.target.checked ? 1 : 0 })
                  }}
                  value={state.isVerify == 1 ? true : false}
                />
                <span className="pl-2">{t('text.passed_inspection')}</span>
              </label>

              <div className="flex gap-x-4 flex-wrap grid sm:grid-cols-2 grid-cols-1">
                {/* section-inputFile */}
                <div className="is-flex is-flex-direction-column flex-1">
                  <p className="title-h1">{t('text.content_file')}</p>
                  <div className="file is-boxed d-flex flex-column">
                    <label className="file-label">
                      <input
                        onChange={fileDoc}
                        accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                        id="doc_file"
                        className="file-input"
                        type="file"
                        name="resume"
                      />
                      <span className="file-cta !w-full is-flex-direction-row is-justify-content-center border-s">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/content/IconFile.png"
                          }
                          alt="Icon"
                        />
                        <div className="is-flex is-flex-direction-column pl-2">
                          {/* <p className="subtitle-p1">เพิ่มไฟล์ประกอบความรู้</p>
                          <span className="subtitle-p2">
                            <span className="subtitle-p">เลือก</span>
                            <span>ไฟล์ (PDF,WORD,POWERPOINT) จากเครื่องของคุณ</span>
                          </span>
                          <p className="subtitle-p3">
                            ไฟล์ต้องมีขนาดไม่เกิน 20 MB เท่านั้น
                          </p> */}
                          <p className="subtitle-p2">{t('text.content_file_desc_100mb')}</p>
                        </div>
                      </span>

                    </label>

                  </div>
                  {fileDocState && (
                    fileDocState.map((item, index) => {
                      return <div key={item.name + index} className="d-flex file-row mt-3" style={{ position: 'relative' }}>
                        <label className="flex-1">
                          {item.name}
                        </label>
                        <button
                          type="button"
                          onClick={(e) => {
                            let files = [...fileDocState];
                            files.splice(index, 1);
                            e.stopPropagation();
                            setfileDocState(files)
                          }} class="delete" style={{ position: 'absolute', right: 10 }}></button>
                      </div>
                    })

                  )}
                </div>
                {/* section-inputVdo */}
                <div className="is-flex is-flex-direction-column flex-1">
                  <p className="title-h1">{t('text.content_video')}</p>
                  <div className="file is-boxed">
                    <label className="file-label">
                      <input
                        className="file-input"
                        accept="video/mp4,video/x-m4v,video/*"
                        onChange={fileVideo}
                        id="video_file"
                        type="file"
                        name="resume"
                      />
                      <span className="file-cta !w-full is-flex-direction-row is-justify-content-center border-s">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/images/content/IconVdo.png"
                          }
                          alt="Icon"
                        />
                        <div className="is-flex is-flex-direction-column pl-2">
                          <p className="subtitle-p2">{t('text.content_video_desc_100mb')}</p>
                        </div>
                      </span>

                    </label>
                  </div>
                  {fileVideoState && (
                    <div className="d-flex file-row mt-3" style={{ position: 'relative' }}>
                      <label className="flex-1">
                        {fileVideoState.name}
                      </label>
                      <button onClick={(e) => {
                        e.stopPropagation();
                        setVideoState("")
                      }}
                        class="delete" style={{ position: 'absolute', right: 10 }}></button>
                    </div>
                  )}
                </div>
              </div>
              <label className="checkbox is-flex mt-4">
                <input
                  id={`checkgdc`}
                  type="checkbox"
                  onChange={(e) => {
                    setState({ ...state, isSpecific: e.target.checked ? 1 : 0 })
                  }}
                  value={state.isSpecific == 1 ? true : false}
                />
                <span className="pl-2">{t('text.specify_content')}</span>
              </label>
              {
                state.isSpecific == 1 && <div className="grid sm:grid-cols-2 grid-cols-1 mt-3 gap-x-4 gap-y-2">
                  <div>
                    <p className="title-h1">{"BU"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.bu.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      hideSelectedOptions={false}
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      required
                      isMulti
                      placeholder="Please Select BU..."
                      onChange={(e) => {
                        var listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        console.log('listData:', listData)
                        setstateOrg({
                          ...stateOrg,
                          subbu: listData.filter(x => x.organizationLevelId == 25),
                          company: listData.filter(x => x.organizationLevelId == 30),
                          division: listData.filter(x => x.organizationLevelId == 50),
                          sub_division: listData.filter(x => x.organizationLevelId == 60),
                          department: listData.filter(x => x.organizationLevelId == 70),
                          sub_department: listData.filter(x => x.organizationLevelId == 80),
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          bu: e.length == 0 ? [] : e.map(x => x.value),
                          subbu: [],
                          company: [],
                          division: [],
                          department: [],
                          section: []
                        });
                      }}
                      options={stateOrg.orgData.filter(x => x.organizationLevelId == 10).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Sub BU"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.subbu.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      required
                      isMulti
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      placeholder="Please Select Sub Bu..."
                      onChange={(e) => {
                        const listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        setstateOrg({
                          ...stateOrg,
                          company: listData.filter(x => x.organizationLevelId == 30),
                          division: listData.filter(x => x.organizationLevelId == 50),
                          sub_division: listData.filter(x => x.organizationLevelId == 60),
                          department: listData.filter(x => x.organizationLevelId == 70),
                          sub_department: listData.filter(x => x.organizationLevelId == 80),
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          subbu: e.length == 0 ? [] : e.map(x => x.value),
                          company: [],
                          division: [],
                          department: [],
                          section: []
                        });
                      }}
                      options={stateOrg.subbu.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Company"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.company.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      required
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      isMulti
                      placeholder="Please Select Company..."
                      onChange={(e) => {
                        const listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        setstateOrg({
                          ...stateOrg,
                          division: listData.filter(x => x.organizationLevelId == 50),
                          sub_division: listData.filter(x => x.organizationLevelId == 60),
                          department: listData.filter(x => x.organizationLevelId == 70),
                          sub_department: listData.filter(x => x.organizationLevelId == 80),
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          company: e.length == 0 ? [] : e.map(x => x.value),
                          division: [],
                          department: [],
                          section: []
                        });
                      }}
                      options={stateOrg.company.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Division"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.division.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      required
                      isMulti
                      placeholder="Please Select Division..."
                      onChange={(e) => {
                        const listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        setstateOrg({
                          ...stateOrg,
                          sub_division: listData.filter(x => x.organizationLevelId == 60),
                          department: listData.filter(x => x.organizationLevelId == 70),
                          sub_department: listData.filter(x => x.organizationLevelId == 80),
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          division: e.length == 0 ? [] : e.map(x => x.value),
                          sub_division: [],
                          department: [],
                          section: []
                        });
                      }}
                      options={stateOrg.division.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Sub Division"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.sub_division.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      required
                      isMulti
                      placeholder="Please Select Sub Division..."
                      onChange={(e) => {
                        const listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        setstateOrg({
                          ...stateOrg,
                          department: listData.filter(x => x.organizationLevelId == 70),
                          sub_department: listData.filter(x => x.organizationLevelId == 80),
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          sub_division: e.length == 0 ? [] : e.map(x => x.value),
                          department: [],
                          section: []
                        });
                      }}
                      options={stateOrg.sub_division.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Department"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.department.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      required
                      isMulti
                      placeholder="Please Select Department..."
                      onChange={(e) => {
                        const listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        setstateOrg({
                          ...stateOrg,
                          sub_department: listData.filter(x => x.organizationLevelId == 80),
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          department: e.length == 0 ? [] : e.map(x => x.value),
                          sub_department: [],
                          section: []
                        });
                      }}
                      options={stateOrg.department.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Sub Department"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.sub_department.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      required
                      isMulti
                      placeholder="Please Select Sub Department..."
                      onChange={(e) => {
                        const listData = [];
                        for (var i = 0; i < e.length; i++) {
                          var filter = stateOrg.orgData.filter((x) => x.departmentParentId === e[i].value);
                          for (var j = 0; j < filter.length; j++) {
                            listData.push(filter[j]);
                          }
                        }
                        setstateOrg({
                          ...stateOrg,
                          section: listData.filter(x => x.organizationLevelId == 90),
                        })
                        setState({
                          ...state,
                          sub_department: e.length == 0 ? [] : e.map(x => x.value),
                          section: []
                        });
                      }}
                      options={stateOrg.sub_department.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                  <div>
                    <p className="title-h1">{"Section"}</p>
                    <Select
                      value={stateOrg.orgData.filter(x => state.section.includes(x.departmentId)).map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      classNames={{
                        multiValueLabel: (state) =>
                          'whitespace-[break-spaces]',
                      }}
                      required
                      isMulti
                      placeholder="Please Select Section..."
                      onChange={(e) => {
                        setState({
                          ...state,
                          section: e.length == 0 ? [] : e.map(x => x.value)
                        });
                      }}
                      options={stateOrg.section.map((x) => {
                        return { label: x.organizationNameEn, value: x.departmentId };
                      })}
                    />
                  </div>
                </div>
              }
              {
                contentType == "LEARNING_PATH" && <div className="mt-4">
                  <hr className="hr-size1" />
                  <div className="is-flex is-justify-content-space-between is-flex-wrap-wrap size-wrap">
                    <div className="is-flex is-align-items-center">
                      <figure className="image mr-3">
                        <img
                          src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                          alt="Icon"
                        />
                      </figure>
                      <p className="title-h1">{"Learning Path"}</p>
                    </div>
                    <div className="is-flex">
                      <button
                        onClick={() => setisModalContentGroup(true)}
                        type="button"
                        className="button min-w-[150px] !bg-[#3b82f6] !text-white is-outlined has-text-weight-bold has-background-light subtitle-p4 mx-2"
                      >
                        {t('text.leanring_path_add')}
                      </button>
                    </div>
                  </div>
                  <div className="p-3 gap-y-2 flex flex-column">
                    {
                      contentGroupSelect.map((d, index) => {
                        return <div className="p-2 border">
                          <div className="flex gap-x-4 items-center">
                            <div className="flex gap-x-1">
                              {/* ตรวจสอบไม่แสดงปุ่ม up สำหรับรายการแรก */}

                              <button type="button" onClick={() => moveItemUp(index)}>
                                <ArrowUpCircleIcon className="h-8 w-8 text-green-500" />
                              </button>


                              {/* ตรวจสอบไม่แสดงปุ่ม down สำหรับรายการสุดท้าย */}

                              <button type="button" onClick={() => moveItemDown(index)}>
                                <ArrowDownCircleIcon className="h-8 w-8 text-red-500" />
                              </button>

                            </div>
                            <PostContentGroup
                              time={ConvertDateShort(d.cttrandate, "DD MMM YYYY HH:mm น.")}
                              totalLike={d.ctlikeAmt}
                              isLike={d.isLike}
                              isBookmark={d.isBookmark}
                              item={d}
                              title={d.ctname}
                              comments={[]}
                              detail={d.ctdeschtml}
                              name={`${d.employee?.firstNameEnglish} ${d.employee?.lastNameEnglish}`}
                              image={
                                d.imageProfile
                                  ? process.env.REACT_APP_IMAGE + d.imageProfile
                                  : process.env.PUBLIC_URL +
                                  "/images/profilePage/Profile.png"
                              }
                              onDelete={
                                () => {
                                  const newItems = [...contentGroupSelect];
                                  newItems.splice(index, 1);
                                  setContentGroupSelect(newItems);
                                }
                              }
                            />
                          </div>
                        </div>
                      })
                    }
                  </div>
                </div>
              }
              {/* <div className="is-flex is-flex-direction-column mx-2">
              <p className="title-h1">รูปภาพเกลเลอรี่</p>
              <div className="file is-boxed">
                <label className="file-label">
                  <input className="file-input" type="file" name="resume" />
                  <span className="file-cta is-flex-direction-row is-justify-content-center border-s1">
                    <img src={process.env.PUBLIC_URL + "/images/content/IconImg.png"} alt="Icon" />
                    <div className="is-flex is-flex-direction-column pl-2">
                      <p className="subtitle-p1">เพิ่มไฟล์ประกอบความรู้</p>
                      <span className="subtitle-p2"><span className="subtitle-p">เลือก</span> ไฟล์รูปภาพจากเครื่องของคุณ</span>
                      <p className="subtitle-p3">ไฟล์ต้องมีขนาดไม่เกิน 20 MB เท่านั้น</p>
                    </div>
                  </span>
                </label>
              </div>
            </div> */}
              <div className="column is-4 pl-5 pt-5 hidden-d">
                <div className="is-flex is-align-items-center mt-4">
                  <figure className="image mr-3">
                    <img
                      src={process.env.PUBLIC_URL + "/images/content/IconChart.png"}
                      alt="Icon"
                    />
                  </figure>
                  <p className="title-h1">{t('text.summary')}</p>
                </div>
                <div className="is-flex mt-4">
                  <div className="is-flex is-flex-direction-column my-1">
                    <p className="subtitle-p5 mr-6">{t('text.create_date')}</p>
                    <p className="subtitle-p5 mr-6">{t('text.content_no')}:</p>
                    <p className="subtitle-p5 mr-6">{t('text.status')}:</p>
                  </div>
                  <div className="is-flex is-flex-direction-column my-1">
                    <p className="subtitle-p5 mr-6">
                      {ConvertDateShort(new Date(), "DD MMMM YYYY")}
                    </p>
                    <p className="subtitle-p5 mr-6">-</p>
                  </div>
                </div>
                <div className="is-flex mt-5">
                  {/* <button to='/' className='button is-outlined has-text-weight-semibold has-text-white subtitle-p4 mx-2 px-5' style={{ backgroundColor: '#F24C20' }}>
                  ดูแบบร่าง
                </button> */}
                  <button
                    onClick={() => {
                      setState({ ...state, ctstatus: "D" });
                      draft();
                    }}
                    type="button"
                    className="button is-outlined has-text-weight-semibold has-background-light subtitle-p4 mx-2 px-4"
                  >
                    {t('text.save_draft')}
                  </button>
                </div>
                {/* <hr className="hr-size2" /> */}
                <div className="column">
                  <div className="is-flex is-align-items-center">
                    <figure className="image mr-3">
                      <img
                        src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                        alt="Icon"
                      />
                    </figure>
                    <p className="title-h2">{t('text.category')}</p>
                  </div>
                  <div className="mt-3" style={{ width: "100%" }}>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      styles={{ width: 200 }}
                      required
                      isMulti
                      onChange={(e) => {
                        setState({
                          ...state,
                          ctcatagoryJson: e,
                        });
                      }}
                      options={catagory.map((x) => {
                        return { label: x.categoryName, value: x.id };
                      })}
                    />
                  </div>
                </div>

                {/* <hr className="hr-size2" /> */}
                <div className="column">
                  <div className="is-flex is-align-items-center">
                    <figure className="image mr-3">
                      <img
                        src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                        alt="Icon"
                      />
                    </figure>
                    <p className="title-h2">{t('text.attention')}</p>
                  </div>
                  <div className="mt-3" style={{ width: "100%" }}>
                    <ReactTags
                      className="form-control form-control-md mt-3"
                      value={tags}
                      name="tags"
                      onChange={(tag) => handleTagAddition(tag)}
                      placeholder="พิมพ์ tag แล้วกด Enter"
                    />
                  </div>
                </div>

                <div className="column">
                  <div className="is-flex is-align-items-center">
                    <figure className="image mr-3">
                      <img
                        src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                        alt="Icon"
                      />
                    </figure>
                    <p className="title-h2">{t('text.project_ref')}</p>
                  </div>
                  <div className="mt-3" style={{ width: "100%" }}>
                    {/* <Autosuggest
                      suggestions={suggestions}
                      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                      onSuggestionsClearRequested={onSuggestionsClearRequested}
                      getSuggestionValue={getSuggestionValue}
                      renderSuggestion={renderSuggestion}
                      inputProps={{
                        placeholder: 'Type a programming language',
                        value: suggestion,
                        onChange: onChangeSuggestion
                      }
                      }
                    /> */}
                  </div>
                </div>
                {/* <hr className="hr-size2" /> */}
                {/* <div className="is-flex is-flex-direction-column">
              <p className="title-h1">รูปภาพเกลเลอรี่</p>
              <div className="file is-boxed">
                <label className="file-label">
                  <input className="file-input" type="file" name="resume" />
                  <span className="file-cta is-flex-direction-row is-justify-content-center border-s2">
                    <img src={process.env.PUBLIC_URL + "/images/content/IconImg.png"} alt="Icon" />
                    <div className="is-flex is-flex-direction-column pl-2">
                      <p className="subtitle-p1">เพิ่มไฟล์ประกอบความรู้</p>
                      <span className="subtitle-p2"><span className="subtitle-p">เลือก</span> ไฟล์รูปภาพจากเครื่องของคุณ</span>
                      <p className="subtitle-p3">ไฟล์ต้องมีขนาดไม่เกิน 20 MB เท่านั้น</p>
                    </div>
                  </span>
                </label>
              </div>
            </div>
        */}
              </div>
            </div>
          </div>
          {/* column-right */}
          <div className="column is-4 hidden-b pl-3 pr-3">
            <div className="is-flex is-align-items-center mt-4">
              <figure className="image mr-3">
                <img
                  src={process.env.PUBLIC_URL + "/images/content/IconChart.png"}
                  alt="Icon"
                />
              </figure>
              <p className="title-h1">{t('text.summary')}</p>
            </div>
            <div className="is-flex mt-4">
              <div className="is-flex is-flex-direction-column my-1">
                <p className="subtitle-p5 mr-6">{t('text.create_date')}</p>
                <p className="subtitle-p5 mr-6">{t('text.content_no')}:</p>
                <p className="subtitle-p5 mr-6">{t('text.status')}:</p>
              </div>
              <div className="is-flex is-flex-direction-column my-1">
                <p className="subtitle-p5 mr-6">
                  {ConvertDateShort(new Date(), "DD MMMM YYYY")}
                </p>
                <p className="subtitle-p5 mr-6">-</p>
              </div>
            </div>
            <div className="is-flex mt-5">
              {/* <button to='/' className='button is-outlined has-text-weight-semibold has-text-white subtitle-p4 mx-2 px-5' style={{ backgroundColor: '#F24C20' }}>
                ดูแบบร่าง
              </button> */}
              <button
                onClick={() => {
                  setState({ ...state, ctstatus: "D" });
                  draft();
                }}
                type="button"
                className="button is-outlined has-text-weight-semibold has-background-light subtitle-p4 mx-2 px-4"
              >
                {t('text.save_draft')}
              </button>
            </div>
            {/* <hr className="hr-size2" /> */}
            <div className="column">
              <div className="is-flex is-align-items-center mt-5">
                <figure className="image mr-3">
                  <img
                    src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                    alt="Icon"
                  />
                </figure>
                <p className="title-h2">{t('text.category')}</p>
              </div>
              <div className="mt-3" style={{ width: "100%" }}>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{ width: 200 }}
                  required
                  isMulti
                  onChange={(e) => {
                    setState({
                      ...state,
                      ctcatagoryJson: e,
                    });
                  }}
                  options={catagory.map((x) => {
                    return { label: x.categoryName, value: x.id };
                  })}
                />
              </div>
            </div>

            {/* <hr className="hr-size2" /> */}
            <div className="column">
              <div className="is-flex is-align-items-center mt-3">
                <figure className="image mr-3">
                  <img
                    src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                    alt="Icon"
                  />
                </figure>
                <p className="title-h2">{t('text.attention')}</p>
              </div>
              <div className="mt-3" style={{ maxWidth: 'fit-content', minWidth: '100%' }}>
                <ReactTags
                  className="form-control form-control-md mt-3"
                  value={tags}
                  name="tags"
                  onChange={(tag) => handleTagAddition(tag)}
                  placeholder="พิมพ์ tag แล้วกด Enter"
                />
              </div>
            </div>
            <hr />
            <div className="column">
              <div className="is-flex is-align-items-center mt-5">
                <figure className="image mr-3">
                  <img
                    src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                    alt="Icon"
                  />
                </figure>
                <p className="title-h2">{t('text.project_ref')}</p>
              </div>
              <div className="mt-3" style={{ maxWidth: 'fit-content', minWidth: '100%' }}>
                <Autosuggest
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={onSuggestionsClearRequested}
                  getSuggestionValue={getSuggestionValue}
                  renderSuggestion={renderSuggestion}

                  inputProps={{
                    placeholder: 'ชื่อโครงการอ้างอิง',
                    value: suggestion,
                    onChange: onChangeSuggestion,
                    className: 'input'
                  }
                  }
                />
              </div>
              <div className="mt-3" style={{ maxWidth: 'fit-content', minWidth: '100%' }}>
                {suggestionSelect && suggestionSelect.map((item, index) => {
                  return (
                    <div style={{ marginTop: 10 }} onClick={(e) => {
                      // func_tag(e, item)
                    }} className="is-flex is-align-items-center">
                      <div className="tag" style={{ fontSize: 12, whiteSpace: 'initial', height: 'auto' }}>
                        <span>{item.ctname}</span>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            var objectUpdate = arrayRemoveByIndex(suggestionSelect, index);
                            setsuggestionsSelect(objectUpdate);
                          }} class="delete"></button>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="column">
              <div className="is-flex is-align-items-center mt-5">
                <figure className="image mr-3">
                  <img
                    src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                    alt="Icon"
                  />
                </figure>
                <p className="title-h2">{t('text.referal')}</p>
              </div>
              <div className="mt-3" style={{ maxWidth: 'fit-content', minWidth: '100%' }}>
                <Autosuggest
                  suggestions={suggestionsUser}
                  onSuggestionsFetchRequested={onSuggestionsFetchRequestedUser}
                  onSuggestionsClearRequested={onSuggestionsClearRequestedUser}
                  getSuggestionValue={getSuggestionValueUser}
                  renderSuggestion={renderSuggestionUser}
                  inputProps={{
                    placeholder: t('text.referal'),
                    value: suggestionUser,
                    onChange: onChangeSuggestionUser,
                    className: 'input'
                  }
                  }
                />
              </div>
              <div className="mt-3" style={{ maxWidth: 'fit-content', minWidth: '100%' }}>
                {suggestionSelectUser && suggestionSelectUser.map((item, index) => {
                  return (
                    <div style={{ marginTop: 10 }} onClick={(e) => {
                      // func_tag(e, item)
                    }} className="is-flex is-align-items-center">
                      <div className="tag" style={{ fontSize: 12, whiteSpace: 'initial', height: 'auto' }}>
                        <span>{item.firstNameEnglish + " " + item.lastNameEnglish}</span>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            var objectUpdate = arrayRemoveByIndex(suggestionSelect, index);
                            setsuggestionsSelectUser(objectUpdate);
                          }} class="delete"></button>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="column">
              <div className="is-flex is-align-items-center mt-5">
                <figure className="image mr-3">
                  <img
                    src={process.env.PUBLIC_URL + "/images/content/Icon1.png"}
                    alt="Icon"
                  />
                </figure>
                <p className="title-h2">{t('text.capabilities')}</p>
                <IconComponent onClick={() => {
                  setisModal(true)
                }} className="h-6 w-6 cursor-pointer ml-2" color="#F24C20" icon={faInfoCircle} />
              </div>
              <div className="mt-3">
                <div className="flex gap-x-2">
                  <Select
                    value={state.competency}
                    className="basic-single w-full"
                    classNamePrefix="select"
                    styles={{ width: 200 }}
                    required
                    isMulti
                    onChange={(e) => {
                      setState({ ...state, competency: e })
                    }}
                    filterOption={filterOption}
                    // options={capabilities.map((x) => {
                    //   return { label: `(${x.fcno}) ${x.competencyNameEn}`, value: x.fcno };
                    // })}
                    options={capabilities}
                  />

                </div>

              </div>
            </div>
            {/* <hr className="hr-size2" /> */}
            {/* <div className="is-flex is-flex-direction-column">
            <p className="title-h1">รูปภาพเกลเลอรี่</p>
            <div className="file is-boxed">
              <label className="file-label">
                <input className="file-input" type="file" name="resume" />
                <span className="file-cta is-flex-direction-row is-justify-content-center border-s2">
                  <img src={process.env.PUBLIC_URL + "/images/content/IconImg.png"} alt="Icon" />
                  <div className="is-flex is-flex-direction-column pl-2">
                    <p className="subtitle-p1">เพิ่มไฟล์ประกอบความรู้</p>
                    <span className="subtitle-p2"><span className="subtitle-p">เลือก</span> ไฟล์รูปภาพจากเครื่องของคุณ</span>
                    <p className="subtitle-p3">ไฟล์ต้องมีขนาดไม่เกิน 20 MB เท่านั้น</p>
                  </div>
                </span>
              </label>
            </div>
          </div>
       */}
          </div>
        </form>
      </div>
      <div class={`modal ${isPreview ? "d-flex" : ""}`}>
        <div class="modal-background"></div>
        <div class="modal-content bg-white p-5">
          {dataPreview.id &&
            // <PostV2Preview
            //   time={ConvertDateShort(dataPreview.cttrandate, "DD MMM YYYY HH:mm น.")}
            //   item={dataPreview}
            //   title={dataPreview.ctname}
            //   detail={dataPreview.ctdeschtml}
            //   name={`${dataPreview.employee?.firstNameEnglish} ${dataPreview.employee?.lastNameEnglish}`}
            //   image={dataPreview.imageProfile ? process.env.REACT_APP_IMAGE + dataPreview.imageProfile : process.env.PUBLIC_URL + "/images/profilePage/Profile.png"}
            // />
            <PostDetailPreview
              page={'detail'}
              contentid={dataPreview.id}
              image={dataPreview.imageProfile ? process.env.REACT_APP_IMAGE + dataPreview.imageProfile : process.env.PUBLIC_URL + "/images/profilePage/Profile.png"}
              name={`${dataPreview.employee?.firstNameEnglish} ${dataPreview.employee?.lastNameEnglish}`}
              time={ConvertDateShort(dataPreview.cttrandate, "DD MMM YYYY HH:mm น.")}
              title={dataPreview.ctname}
              detail={dataPreview.ctdeschtml}
              item={dataPreview}
              comments={[]}
            />
          }
        </div>
        <button onClick={() => {
          setisPreview(false);
          setdataPreview({});
        }}
          class="modal-close is-large" aria-label="close"></button>
      </div>
      <div class={`modal  ${isModal ? "d-flex" : ""}`}>
        <div class="modal-background"></div>
        <div class="modal-content !w-full sm:!w-3/4 bg-white p-5" style={{ borderRadius: 5 }}>
          <h1 className="text-2xl">{t('text.capabilities')}</h1>
          <div className="flex-column overflow-auto max-h-[500px] mt-3">
            <div className="pr-2">
              <input
                className="input"
                type="text"
                value={searchCapacity}
                onChange={(e) => setsearchCapacity(e.target.value)}
                placeholder="ค้นหา"
              />
            </div>
            <div className="flex flex-col gap-y-2 mt-2">
              {
                capabilitiesDefault.filter(x => x.label.includes(searchCapacity)).map((item, index) => {
                  return <div className="flex flex-col gap-y-1">
                    <span className="font-bold text-lg">{item.label}:</span>
                    <span className="text-gray-">{item.description}</span>
                  </div>
                })
              }

            </div>
          </div>
        </div>
        <button onClick={() => {
          setisModal(false);
        }}
          class="modal-close is-large" aria-label="close"></button>
      </div>
      <div class={`modal modal ${isModalContentGroup ? "d-flex" : ""}`}>
        <div class="modal-background"></div>
        <div class="modal-content bg-white p-5 flex flex-column gap-y-4" style={{ borderRadius: 5 }}>
          <div
            className="flex justify-between items-center"
          >
            <span className="font-bold text-lg">  {t('text.leanring_path_add')}</span>
            <XMarkIcon onClick={() => {
              setisModalContentGroup(false)
            }} className="w-6 h-6 cursor-pointer" />
          </div>
          <div className="flex flex-column gap-y-2">
            {/* <input className="input size-input" placeholder="#ชื่อกลุ่ม" /> */}
            <Autosuggest
              suggestions={suggestionContentGroups}
              onSuggestionsFetchRequested={onSuggestionsContentGroupFetchRequested}
              onSuggestionsClearRequested={onSuggestionsContentGroupClearRequested}
              getSuggestionValue={getSuggestionValueContentGroup}
              renderSuggestion={renderSuggestionContentGroup}
              inputProps={{
                placeholder: 'ชื่อโครงการอ้างอิง',
                value: suggestionContentGroup,
                onChange: onChangeSuggestionContentGroup,
                className: 'input'
              }
              }
            />
          </div>
          <div className="flex flex-column gap-y-2">
            <span className="font-bold">{t('text.leanring_path_added')}</span>
            {
              suggestionContentGroupSelect.map((d, index) => {
                // return <div className="flex-1 relative" key={"userSelect-" + index}>
                //   <div className="flex justify-between items-center">
                //     <div className="flex justify-between items-center gap-x-3">
                //       <figure className="image is-48x48">
                //         <img
                //           className={`is-rounded image-cover ${item.smeCategory ? `border-[#f97316] border-4` : ""}`}
                //           style={{ width: '100%', height: '100%' }}
                //           src={item.image
                //             ? process.env.REACT_APP_IMAGE + item.image
                //             : process.env.PUBLIC_URL +
                //             "/images/profilePage/Profile.png"} />
                //       </figure>
                //       <span>
                //         {item.firstNameEnglish + " " + item.lastNameEnglish}
                //       </span>
                //     </div>
                //     <XMarkIcon onClick={() => {
                //       const x = suggestionSelectUser.splice(index, 1);
                //       setSuggestionsUser(x);
                //     }} className="w-6 h-6 cursor-pointer" />
                //   </div>
                // </div>
                return <div className="px-2 py-4 border">
                  <PostContentGroup
                    time={ConvertDateShort(d.cttrandate, "DD MMM YYYY HH:mm น.")}
                    totalLike={d.ctlikeAmt}
                    isLike={d.isLike}
                    isBookmark={d.isBookmark}
                    item={d}
                    title={d.ctname}
                    comments={[]}
                    detail={d.ctdeschtml}
                    name={`${d.employee?.firstNameEnglish} ${d.employee?.lastNameEnglish}`}
                    image={
                      d.imageProfile
                        ? process.env.REACT_APP_IMAGE + d.imageProfile
                        : process.env.PUBLIC_URL +
                        "/images/profilePage/Profile.png"
                    }
                    onDelete={
                      () => {
                        const newItems = [...suggestionContentGroupSelect];
                        newItems.splice(index, 1);
                        setSuggestionContentGroupSelect(newItems);
                      }
                    }
                  />
                </div>
              })
            }
          </div>
          <div className="flex justify-end gap-x-4 items-center">
            <span className="cursor-pointer" onClick={() => {
              setisModalContentGroup(false);

            }}>{t("menu.cancel")}</span>
            <div onClick={() => {
              setisModalContentGroup(false);
              setContentGroupSelect([...contentGroupSelect, ...suggestionContentGroupSelect]);
              setSuggestionContentGroupSelect([]);
            }} className="cursor-pointer bg-[#3273DC] text-[#FFF] px-4 py-2 rounded-lg">
              <span>  {t('text.leanring_path_add')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateContent;
